import IconPicker from '../../../scripts/iconpicker-1.5.0.js';

angular.module("eventHosts")

    .controller("EventHostsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENT_HOSTS_WRITE");
            $rootScope.title = $filter('translate')('event-hosts.title');


            IconPicker.Init({
                // Required: You have to set the path of IconPicker JSON file to "jsonUrl" option. e.g. '/content/plugins/IconPicker/dist/iconpicker-1.5.0.json'
                jsonUrl: '/assets/iconpicker-1.5.0.json',
                // Optional: Change the buttons or search placeholder text according to the language.
                searchPlaceholder: 'Search Icon',
                showAllButton: 'Show All',
                cancelButton: 'Cancel',
                noResultsFound: 'No results found.', // v1.5.0 and the next versions
                borderRadius: '20px', // v1.5.0 and the next versions
            });

            IconPicker.Run('#GetIconPicker', function () {
                // ng-bind no funciona para asignar el icono porque no detecta el cambio que hacemos con el IconPicker, así que hay que hacerlo a pelo.
                let icon = document.querySelector("#IconPreview").getAttribute("class");
                icon = icon.substring(icon.indexOf('-')+1);
                $scope.event_host.icon = icon;

            });

            $scope.event_host_id = $stateParams.id;
           

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('event-hosts.title'), url: "eventHosts.list" },
                    { title: $filter('translate')('event-hosts.add') },
                ];

                $scope.event_host = {};

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('event-hosts.title'), url: "eventHosts.list" },
                    { title: $filter('translate')('general.edit') },
                ];

                Restangular.one('EventHosts', $stateParams.id).get().then(function (result) {
                    $scope.event_host = result;
                });
            }

            $scope.save = function (frmEventHosts) {

                if (!angular.isUndefined($scope.event_host.id)) {
                    $scope.event_host.put().then(function (result) {
                        if (typeof (result.id) != "undefined") {
                            toastr.success($filter('translate')('event_host.modified_success'));
                            $state.go("event_hosts.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('EventHosts').post($scope.event_host).then(function (result) {
                        if (typeof (result.id) != "undefined") {
                            toastr.success($filter('translate')('event_host.created_success'));
                            $state.go("event_hosts.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }


            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('event_host.delete'),
                    message: $filter('translate')('event_host.delete_message') + " " + $scope.event_host.name + "?",
                    onAccept: function () {
                        $scope.event_host.remove().then(function () {
                            toastr.success($filter('translate')('event_host.remove_success'));
                            $state.go("event_hosts.list");
                        });
                    }
                });
            };

    }])

    ;

